export default "__VITE_ASSET__6ad75dbc__"